import req from './api';
const auth = {
    login(params) {
        return req('post', '/auth', params);
    }
};
export default auth;
